import type { SVGProps } from "react";
import * as React from "react";

const SvgBriefcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 21a1 1 0 1 0 2 0zM14 3V2zm-4 0V2zM8 5H7zM7 21a1 1 0 1 0 2 0zM4 8h16V6H4zm16 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v10h2V9zm0 10a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H4v2h16zM4 20a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zm-1-1V9H1v10zM3 9a1 1 0 0 1 1-1V6a3 3 0 0 0-3 3zm14 12V5h-2v16zm0-16a3 3 0 0 0-.879-2.121l-1.414 1.414A1 1 0 0 1 15 5zm-.879-2.121A3 3 0 0 0 14 2v2a1 1 0 0 1 .707.293zM14 2h-4v2h4zm-4 0a3 3 0 0 0-2.121.879l1.414 1.414A1 1 0 0 1 10 4zm-2.121.879A3 3 0 0 0 7 5h2a1 1 0 0 1 .293-.707zM7 5v16h2V5z"
    />
  </svg>
);
export default SvgBriefcase;
